export default {
  wallet: {
    title: 'Carteira',
    balance: 'Saldo',
    deposit: 'Depósito',
    withdraw: 'Sacar',
    rollover: 'Rollover',
    transaction: 'Transação',
    myBet: 'Minhas Apostas',
    totalBalance: 'Saldo Total',
    withdrawableBalance: 'Saldo Sacável',
    bonus: 'Bônus',
    bonusBalance: 'Saldo de Bônus',
    cashBalance: 'Saldo em Dinheiro',
    withdrawable: 'Sacável',
    depositNow: 'Depositar Agora',
    getBonus: 'Obter Bônus',
    bonusGames: 'Jogos com Bônus',
    playNow: 'Jogar Agora',
    fiatAccount: 'Conta Fiat',
    cash: 'Dinheiro',
    rules: 'Regras',
    ruleQ1: '1. O que é Bônus?',
    ruleA1: 'Bônus são recompensas dadas pela plataforma após participar de atividades e podem ser usados para apostar em jogos com bônus designados.',
    ruleQ2: '2. Como posso usar o bônus?',
    ruleA2: 'O bônus só pode ser usado para apostas depois que o saldo da carteira em dinheiro se esgotar. O bônus deve atingir o requisito de apostas antes de poder ser convertido para a carteira em dinheiro.',
    ruleQ3: '3. Quais jogos aceitam apostas com bônus?',
    ruleA3: 'A maioria dos jogos de slot aceita apostas com bônus. Para uma lista detalhada de jogos, consulte a página de Jogos com Bônus.',
    ruleQ4: '4. Existem restrições para converter o bônus em carteira em dinheiro?',
    ruleA4: 'Assim que os requisitos de apostas com bônus forem atingidos, você pode converter o bônus original para a carteira em dinheiro na Central de Recompensas. Qualquer lucro de bônus restante será devolvido à Carteira de Bônus, e os requisitos de apostas serão recalculados.',
    ruleQ5: '5. Existem restrições para converter o lucro do bônus em carteira em dinheiro?',
    ruleA5: 'O lucro do bônus deve atingir um requisito de apostas de 15x. O lucro máximo de bônus que pode ser convertido para a carteira em dinheiro é USDT5.000,00, e o valor máximo por aposta é USDT1.000,00.',
    ruleQ6: '6. Como o requisito de apostas é calculado?',
    ruleA6: 'Jogos de slot: Valor apostado = Requisito de apostas. Outros jogos: Valor apostado = Valor absoluto do lucro (até o valor da aposta)',
    select: 'Selecionar',
    currency: 'Moeda',
    loading: 'Carregando...',
    noMoreData: 'Sem mais dados',
    noData: 'Sem dados',
    colType: 'Tipo',
    colTime: 'Hora',
    colStatus: 'Status',
    colAmount: 'Valor',
    colBalance: 'Saldo',
    allType: 'Todos os Tipos',
    allStats: 'Todos os Status',
    colWallet: 'Carteira',
    colCurrent: 'Atual',
    colRequired: 'Exigido',
    colStats: 'Status',
    totalVaultBalance: 'Saldo Total do Cofre',
    amount: 'Valor',
    availableBalance: 'Saldo Disponível:',
    max: 'MÁX',
    depositInVault: 'Depositar no Cofre',
    depositCurrency: 'Moeda de Depósito',
    currencyBalance: 'Saldo por Moeda',
    history: 'Histórico',
    vaultRules: 'Regras do Cofre',
    vaultRule1: 'O Cofre é um lugar seguro para guardar fundos sem se preocupar com taxas de transação ou atrasos no blockchain. O Cofre funciona como sua própria carteira digital ou até como uma conta poupança em um banco. É extremamente seguro – graças ao 2FA – e você pode adotar medidas de segurança reforçadas para cuidar dos fundos.',
    vaultRule2: 'O depósito e o saque de fundos no Cofre são protegidos por 2FA e podem ser acessados pelo depositante a qualquer momento.',
    vaultRule3: 'Os fundos no Cofre não serão tocados por ninguém além do depositante. É seu, e ficará sempre seguro para você usar!',
    selectTime: 'Selecionar Período',
    colGame: 'Jogo',
    colBet: 'Aposta',
    colWin: 'Ganho',
    colProfit: 'Lucro',
    sports: 'Esportes',
    allGames: 'Todos os jogos',
    today: 'Hoje',
    yesterday: 'Ontem',
    last3Days: 'Últimos 3 dias',
    last7Days: 'Últimos 7 dias',
    last15Days: 'Últimos 15 dias',
    last30Days: 'Últimos 30 dias',
  },
};
